
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
  @Component({
    filters: {
      formatDate: function(value, type) {
        if (!value) {
          return
        }
        let date = new Date(value * 1000)
        let y: any = date.getFullYear()
        let MM: any = date.getMonth() + 1
        MM = MM < 10 ? ('0' + MM) : MM
        let d: any = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let h: any = date.getHours()
        let next_h = h < 10 ? ('0' + (h + 1)) : (h + 1)
        h = h < 10 ? ('0' + h) : h
        let m: any = date.getMinutes()
        m = m < 10 ? ('0' + m) : m
        let s: any = date.getSeconds()
        s = s < 10 ? ('0' + s) : s
        if (type == 1) {
          return y + '-' + MM + '-' + d + ' ' + h + ':' + m + '-' + next_h + ':' + m
        } else if (type == 2) {
          return y + '-' + MM + '-' + d + ' ' + h + ':' + m
        }
      }
    }
  })
export default class AddList extends Vue {
    @Prop() from: string
    @Prop() studentId: string
    @Prop() action: boolean
    @Prop() logHeight: number

    logesList: any = []
    total_count: number = 0
    logesPage: number = 1
    logesSize: number = 10


    @Watch('action')
    getList(newValue, oldValue){
      if(this.action) {
        this.getLogsList()
      }
    }

    // 日志list
    async getLogsList (){
      const res:any = await CourseModule.logsList({ employee_id: '', data_id: this.studentId, table_name: this.from, type: '4,1', start_time: '', end_time: '', page: this.logesPage, size: this.logesSize, data_name: ''})
      if(res.code === 200) {
        this.logesList = res.data.list
        this.total_count = res.data.total
        this.$emit('add-logs', true)
      }
    }
    handleCurrentChange(val) {
      this.logesPage = val
      this.getLogsList()
    }

    async updata(val){
      let data = {
        id: val.id,
        remark: val.remark
      }
      const res:any = await CourseModule.modifyLogs(data)
      if(res.code === 200) {
        this.$message({
          type: 'success',
          message: '修改成功!'
        })
      } else {
        this.$message.error('修改失败！')
      }
    }
    async logModify(id,val) {
      this.updata(val)
    }

    mounted() {
      if(this.from === 'edu_customer' || this.from === 'edu_business' || this.from === 'edu_order') {
        this.getLogsList()
      }
    }
}
